<template>
  <div>
    <div :id="VIEW_LIST" v-if="viewType == VIEW_LIST">
      <div class="row center-block">
        <div class="col-md-12">
          <div class="box">
            <div class="box-header">
                <label for="recordPerPage" class="col-sm-1 col-md-1 col-lg-1" style="margin-top: 10px; text-align:left">Show</label>
                <div class="col-sm-2 col-md-2 col-lg-1" style="padding-left:0px;">
                  <select v-on:change="changePageSize" ref="recordPerPage" class="form-control">
                    <option v-if="inquiryParam.pageSize == 5" selected>5</option><option v-else>5</option>
                    <option v-if="inquiryParam.pageSize == 10" selected>10</option><option v-else>10</option>
                    <option v-if="inquiryParam.pageSize == 20" selected>20</option><option v-else>20</option>
                    <option v-if="inquiryParam.pageSize == 50" selected>50</option><option v-else>50</option>
                    <option v-if="inquiryParam.pageSize == 100" selected>100</option><option v-else>100</option>
                  </select>
                </div>          
                <div class="box-tools">              
                  <!-- <button v-on:click="onCreate" class="btn btn-primary">Create</button> -->
                  <button class="btn btn-default" data-toggle="modal" data-target="#modal-filter">Filter</button>
                  <button v-on:click="inquiry" class="btn btn-warning">Search</button>
                </div>
            </div>        
            <div class="box-body no-padding table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="width: 45px;text-align:right;">#</th>
                    <th style="text-align:center;">Action</th>
                    <th style="text-align:left;">Name</th>
                    <th style="text-align:left;">Project</th>
                    <th style="text-align:left;">Cashier</th>
                    <th style="text-align:left;">Point of Sales</th>
                    <th style="text-align:center;">Opening Date</th>
                    <th style="text-align:center;">Closing Date</th>
                    <th style="text-align:right;">Opening Balance</th>
                    <th style="text-align:right;">Transaction Balance</th>
                    <th style="text-align:right;">Closing Balance</th>
                    <th style="text-align:right;">Different</th>
                    <th style="text-align:center;">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in listData" v-bind:key="i">
                    <td style="width:45px;text-align:right;">{{ startSequence + i + 1}}</td>
                    <td style="width:85px;text-align:center;">
                      <a href="#" v-on:click="onDisplay(row)" ref="displayRow" style="padding-right:5px">
                        <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                      </a>
                      <!-- <a href="#" v-on:click="onEdit(row)" ref="editRow" style="padding-right:5px">
                        <span class="icon ion-edit" data-toggle="tooltip" data-placement="right" title="Edit"></span>
                      </a> -->
                    </td>
                    <td style="text-align:left;">{{ row.name }}</td>
                    <td style="text-align:left;" class="text-nowrap">{{ row.projectName }}</td>
                    <td style="text-align:left;" class="text-nowrap">{{ row.cashierName }}</td>
                    <td style="text-align:left;" class="text-nowrap">{{ row.pointOfSalesName }}</td>
                    <td style="text-align:center;">{{ row.openingDate }}</td>
                    <td style="text-align:center;">{{ row.closingDate }}</td>
                    <td style="text-align:right;">{{ row.openingBalance }}</td>
                    <td style="text-align:right;">{{ row.transactionBalance }}</td>
                    <td style="text-align:right;">{{ row.closingBalance }}</td>
                    <td style="text-align:right;">{{ row.different }}</td>
                    <td style="text-align:center;">
                      <span v-if="row.status == SESSION_NEW" class="badge bg-blue">{{ row.status }}</span>
                      <span v-if="row.status == SESSION_INPROGRESS" class="badge bg-yellow">{{ row.status }}</span>
                      <span v-if="row.status == SESSION_CLOSED" class="badge bg-green">{{ row.status }}</span>
                      <span v-if="row.status == SESSION_POSTED" class="badge bg-purple">{{ row.status }}</span>
                    </td>
                    <td hidden>{{ row.id }}</td>
                    <td hidden>{{ row.projectId }}</td>
                    <td hidden>{{ row.cashierId }}</td>
                    <td hidden>{{ row.pointOfSalesId }}</td>                    
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="box-footer">
              <div class="form-group">
                <label style="width:25px;text-align:right;">
                    <a href="#"><i v-on:click="changePage(1)" class="icon ion-ios-rewind"></i></a>
                </label>
                <label style="width:35px;text-align:center;">
                    <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber - 1)" class="icon ion-arrow-left-b"></i></a>
                </label>
                <label>
                    Page
                </label>
                <label>
                    <input v-model="inquiryParam.CurrentPageNumber" v-on:keyup.enter="gotoPage($event)" class="form-control" id="CurrentPage" style="width:50px;margin-left:5px;margin-right:5px;">
                </label>
                <label id="TotalPageText">
                  {{ totalPages }}                
                </label>
                <label style="width:35px;text-align:center;">
                    <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber + 1)" class="icon ion-arrow-right-b"></i></a>
                </label>
                <label style="width:25px;text-align:left;">
                    <a href="#"><i v-on:click="changePage(totalPages)" class="icon ion-ios-fastforward"></i></a>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modal-filter" style="display: none;">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span></button>
            <h4 class="modal-title">Filter</h4>
          </div>
          <div class="modal-body">
            <div class="box-body no-border form-horizontal">
              <div class="form-group">
                <label class="col-md-2 control-label">POS Session</label>
                <div class="col-md-10">
                    <input type="text" id="filterPOSSession" v-model="searchParam.name" style="width:100%">
                </div>                     
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">Opening Date</label>
                <div class="col-md-10">
                  <div class="input-group">
                    <datepicker v-if="showOpenDateFrom" ref="openDateFrom" :value=searchParam.open_date_from :format=DATE_FORMAT :input-attr="{ 'id': 'filterOpenDateFrom' }" :input-style="{ 'width': '100%' }"></datepicker>
                    <label>to</label>
                    <datepicker v-if="showOpenDateTo" ref="openDateTo" :value=searchParam.open_date_to :format=DATE_FORMAT :input-attr="{ 'id': 'filterOpenDateTo' }" :input-style="{ 'width': '100%' }"></datepicker>
                  </div>
                </div>                     
              </div>               
              <!-- <div class="form-group">
                <label class="col-md-2 control-label">Cashier</label>
                <div class="col-md-10">
                  <input type="text" id="filterCashier" v-model="searchParam.cashier" style="width:100%">
                </div>                     
              </div>                 -->
              <div class="form-group">
                <label class="col-md-2 control-label">Status</label>
                <div class="col-md-10">
                  <input type="text" id="filteStatus" v-model="searchParam.status" style="width:100%">
                </div>                     
              </div>                                                                                         
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" ref="btnCloseModal">Close</button>
            <button type="button" class="btn btn-primary" data-dismiss="modal" @click="onApplyFilter($event)">Apply</button>
            <button type="button" class="btn btn-primary" @click="onResetFilter($event)">Reset</button>
          </div>
        </div>
      </div>
    </div>    
  </div>  
</template>

<script>
// import $ from 'jquery'
import api from '../../api'
import SweetAlert from 'sweetalert2'
import datepicker from '../../components/widgets/DatePicker'
import config from '../../config'
import $ from 'jquery'
import moment from 'moment'

const VIEW_LIST = 'list'
const MODE_CREATE = 'create'
const MODE_VIEW = 'read'
// const MODE_UPDATE = 'update'
const SESSION_NEW = 'New'
const SESSION_INPROGRESS = 'InProgress'
const SESSION_CLOSED = 'Closed'
const SESSION_POSTED = 'Posted'

export default {
  name: 'POSSession',
  components: {
    datepicker
  },
  data() {
    return {
      DATE_FORMAT: config.dateFormat,
      DATETIME_FORMAT_ISO: config.dateTimeFormatSql,
      VIEW_LIST: VIEW_LIST,
      SESSION_NEW: SESSION_NEW,
      SESSION_INPROGRESS: SESSION_INPROGRESS,
      SESSION_CLOSED: SESSION_CLOSED,
      SESSION_POSTED: SESSION_POSTED,
      listData: null,
      listDataTemp: null,
      totalRows: 0,
      totalPages: 0,
      startSequence: 0,
      inquiryParam: {
        WhereClause: '',
        CurrentPageNumber: 1,
        PageSize: 10,
        SortDirection: 'DESC',
        SortExpression: 'Name',
        WhereClauseByProject: ''
      },
      searchParam: {
        name: '',
        open_date_from: '',
        open_date_to: '',
        cashier: '',
        status: ''
      },
      viewType: VIEW_LIST,
      tabActive: '',
      listProject: null,
      listCashier: null,
      listPOS: null,
      showValidFrom: false,
      showOpenDateFrom: true,
      showOpenDateTo: true
    }
  },
  computed: {
  },
  created() {
    this.viewType = VIEW_LIST
    this.inquiry()
  },
  mounted() {
    this.$refs.recordPerPage.value = this.inquiryParam.PageSize
  },
  methods: {
    changePageSize(evt) {
      this.inquiryParam.PageSize = evt.target.value
      this.inquiryParam.CurrentPageNumber = 1
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    gotoPage(evt) {
      if (evt.target.value > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else if (evt.target.value < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    changePage(page) {
      if (page < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      } else if (page > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else {
        this.inquiryParam.CurrentPageNumber = page
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    onSearch(evt) {
      // var keyWords = evt.target.value
      // var whereClause = ['Name', 'like', '\'%' + keyWords + '%\'']
      // this.inquiryParam.WhereClause = whereClause.join(' ')
      this.inquiry()
    },
    inquiry() {
      this.inquiryParam.WhereClauseByProject = ''
      if (this.$store.state.userInfo.projects && this.$store.state.userInfo.projects.length > 0) {
        this.inquiryParam.WhereClauseByProject = 'ProjectId IN (' + this.$store.state.userInfo.projects.join() + ')'
        this.inquiryParam.WhereClauseByProject = this.inquiryParam.WhereClause === '' ? this.inquiryParam.WhereClauseByProject : this.inquiryParam.WhereClauseByProject + ' AND '
      }

      api
        .request('POS', 'get', '/api/Session/Inquiry?WhereClause=' + this.inquiryParam.WhereClauseByProject + this.inquiryParam.WhereClause +
                                 '&PageSize=' + this.inquiryParam.PageSize + '&CurrentPageNumber=' + this.inquiryParam.CurrentPageNumber +
                                 '&SortDirection=' + this.inquiryParam.SortDirection + '&SortExpression=' + this.inquiryParam.SortExpression, null)
        .then(response => {
          if (response.data.entity == null) {
            this.listData = []
            return
          }

          var data = response.data
          this.listDataTemp = data.entity
          this.total = data.totalRows
          this.totalPages = data.totalPages
          this.$refs.recordPerPage.value = this.inquiryParam.PageSize

          // Populate Cashier & Project
          var arrCashier = []
          var arrProject = []
          var arrPOS = []
          this.listDataTemp.forEach(itemSession => {
            arrCashier.push(itemSession.cashierId)
            var arrCashierUnique = arrCashier.filter(function(item, index) {
              return arrCashier.indexOf(item) >= index
            })
            arrCashier = arrCashierUnique

            arrProject.push(itemSession.projectId)
            var arrProjectUnique = arrProject.filter(function(item, index) {
              return arrProject.indexOf(item) >= index
            })
            arrProject = arrProjectUnique

            arrPOS.push(itemSession.pointOfSalesId)
            var arrPOSUnique = arrPOS.filter(function(item, index) {
              return arrPOS.indexOf(item) >= index
            })
            arrPOS = arrPOSUnique
          })

          this.getCashierName(arrCashier, arrProject, arrPOS)
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getCashierName(arrCashier, arrProject, arrPOS) {
      let whereClause = 'id in (' + arrCashier.join(',') + ')'
      api
        .request('Account', 'get', '/api/Account/Inquiry?WhereClause=' + whereClause + '&PageSize=' + arrCashier.length +
                                      '&CurrentPageNumber=1&SortDirection=ASC&SortExpression=id', null)
        .then(response => {
          var data = response.data
          this.listCashier = data.entity

          var cashierName
          this.listDataTemp.forEach(itemSession => {
            cashierName = ''
            this.listCashier.some(function(item, index) {
              if (itemSession.cashierId === item.id) {
                cashierName = item.name
              }
            })
            itemSession.cashierName = cashierName
          })
          this.getProjectName(arrProject, arrPOS)
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getProjectName(arrProject, arrPOS) {
      let whereClause = 'id in (' + arrProject.join(',') + ')'
      api
        .request('Account', 'get', '/api/Project/Inquiry?WhereClause=' + whereClause + '&PageSize=' + arrProject.length +
                                      '&CurrentPageNumber=1&SortDirection=ASC&SortExpression=id', null)
        .then(response => {
          var data = response.data
          this.listProject = data.entity

          var projectName
          this.listDataTemp.forEach(itemPOS => {
            projectName = ''
            this.listProject.some(function(item, index) {
              if (itemPOS.projectId === item.id) {
                projectName = item.name
              }
            })
            itemPOS.projectName = projectName
          })
          this.getPointOfSalesName(arrPOS)
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getPointOfSalesName(arrPOS) {
      let whereClause = 'id in (' + arrPOS.join(',') + ')'
      api
        .request('POS', 'get', '/api/POS/Inquiry?WhereClause=' + whereClause + '&PageSize=' + arrPOS.length +
                                      '&CurrentPageNumber=1&SortDirection=ASC&SortExpression=id', null)
        .then(response => {
          var data = response.data
          this.listPOS = data.entity

          var pointOfSalesName
          this.listDataTemp.forEach(itemPOS => {
            pointOfSalesName = ''
            this.listPOS.some(function(item, index) {
              if (itemPOS.pointOfSalesId === item.id) {
                pointOfSalesName = item.name
              }
            })
            itemPOS.pointOfSalesName = pointOfSalesName
          })
          this.listData = this.listDataTemp
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onCreate() {
      let params = {
        id: 0,
        mode: MODE_CREATE,
        callback: this.$route.name
      }
      this.$router.push({ name: 'POS Session', params: params })
    },
    onDisplay(row) {
      let params = {
        id: row.id,
        mode: MODE_VIEW,
        callback: this.$route.name
      }
      this.$router.push({ name: 'POS Session', params: params })
    },
    // onEdit(row) {
    //   let params = {
    //     id: row.id,
    //     mode: MODE_UPDATE
    //   }
    //   this.$router.push({ name: 'POSSessionForm', params: params })
    // }
    onApplyFilter() {
      var filterParams = []
      if (this.searchParam.name !== '') {
        filterParams.push(['name', '=', '\'' + this.searchParam.name + '\''])
      }

      let dateFrom
      if ($('#filterOpenDateFrom').val() === '') {
        dateFrom = moment('01.01.1900', this.DATE_FORMAT)
      } else {
        this.searchParam.open_date_from = $('#filterOpenDateFrom').val()
        dateFrom = moment(this.searchParam.open_date_from, this.DATE_FORMAT)
      }
      dateFrom = moment(dateFrom).format(this.DATE_FORMAT_ISO) + ' 00:00:00'
      dateFrom = this.convertToUtcTime(dateFrom, this.DATETIME_FORMAT_ISO)
      filterParams.push(['OpeningDate', '>=', '\'' + dateFrom + '\''])

      let dateTo
      if ($('#filterOpenDateTo').val() === '') {
        dateTo = moment('31.12.9999', this.DATE_FORMAT)
      } else {
        this.searchParam.open_date_to = $('#filterOpenDateTo').val()
        dateTo = moment(this.searchParam.open_date_to, this.DATE_FORMAT)
      }
      dateTo = moment(dateTo).format(this.DATE_FORMAT_ISO) + ' 00:00:00'
      dateTo = this.convertToUtcTime(dateTo, this.DATETIME_FORMAT_ISO)
      filterParams.push(['OpeningDate', '<=', '\'' + dateTo + '\''])

      if (this.searchParam.cashier !== '') {
        filterParams.push(['Cashier', '=', '\'' + this.searchParam.cashier + '\''])
      }
      if (this.searchParam.status !== '') {
        filterParams.push(['status', '=', '\'' + this.searchParam.status + '\''])
      }

      var whereClause = []
      var j = 0
      for (let i = 0; i < filterParams.length; i++) {
        whereClause[j] = filterParams[i].join(' ')
        j++
      }
      this.inquiryParam.WhereClause = whereClause.join(' AND ')
      this.onSearch()
    },
    onResetFilter() {
      this.inquiryParam.WhereClause = ''
      this.searchParam.name = ''

      this.searchParam.open_date_from = ''
      this.searchParam.open_date_to = ''

      this.searchParam.cashier = ''
      this.searchParam.status = ''

      this.showOpenDateFrom = false
      this.$nextTick(() => {
        this.showOpenDateFrom = true
      })

      this.showOpenDateTo = false
      this.$nextTick(() => {
        this.showOpenDateTo = true
      })
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
input[type=text], select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none;
  border-right-style: none;
  border-left-style: none;
  color: #777;
  margin: 0px;
}
input:focus {
  outline: none;
  border-bottom: 2px solid #337AB7;
}

.q_avatar {
  float: left;
  box-sizing: border-box;
  position: relative;
  text-align: inherit;
}
.q_avatar > img {
  max-height: 90px;
  max-width: 90px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  border: none;
}
.q_form_image_controls {
  position: absolute;
  top: 0;
  left: auto;
  bottom: auto;
  right: 0;
  width: 100%;
  color: white;
  background-color: #337AB7;
  opacity: 0;
  transition: opacity ease 400ms;
}
.q_hidden_input_file {
  position: absolute;
  top: 1px;
  opacity: 0;
  width: 100%;
  height: 26px;  
  display: none;
}
.q_form_image_controls > .ion {
  margin: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// POSSession.vue?d304a27e